// @ts-ignore // tmp
export const isClient = typeof window !== 'undefined'
